import type { ApolloError } from '@apollo/client';
import { endOfDay, startOfDay } from 'date-fns';
import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { genericScalars } from '../lib/graphql/helpers';
import { userShiftClashReportSelector } from './selectors/shift';

export const queryUserShiftClashReportName = 'queryUserShiftClashReport';

/**
 * Queries the shift clash report for the provided users for the provided date range.
 * @param userIds ids of the users that will be used to retrieve the report.
 * @param from date of the shifts query to detect shift clashes.
 * @param to date of the shifts query to detect shift clashes.
 * @returns shift clash reports for the provided users.
 */
const useQueryUserShiftClash = (
  userIds: readonly string[],
  from: Date,
  to: Date,
  onError: (e: ApolloError) => void
) =>
  useTypedQuery(
    {
      queryShiftClashReport: [
        {
          fromDate: startOfDay(from),
          toDate: endOfDay(to),
          userIds: [...userIds],
        },
        userShiftClashReportSelector,
      ],
    },
    {
      apolloOptions: {
        onError,
        skip: userIds.length === 0,
      },
      scalars: genericScalars,
      operationOptions: {
        operationName: queryUserShiftClashReportName,
      },
    }
  );

export default useQueryUserShiftClash;
